import { render, staticRenderFns } from "./PlaceOrderError.vue?vue&type=template&id=8b9f1e72&scoped=true"
import script from "./PlaceOrderError.vue?vue&type=script&lang=js"
export * from "./PlaceOrderError.vue?vue&type=script&lang=js"
import style0 from "./PlaceOrderError.vue?vue&type=style&index=0&id=8b9f1e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9f1e72",
  null
  
)

export default component.exports